import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "graphql/mutations";
import { listAgencys, createAgency, updateAgency } from "services/apiMiddleware";
import { replaceArrayItem } from "services/utils";
import { t } from "../../i18n";

const agencys = {
  state: {
    isLoading: false,
    error: null,
    items: [],
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadSuccess: (state, items) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items,
      };
    },
    createSuccess: (state, newItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: [...state.items, newItem],
      };
    },
    updateSuccess: (state, updatedItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: replaceArrayItem(state.items, (item) => item.id === updatedItem.id, updatedItem),
      };
    },
    deleteSuccess: (state, deletedId) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: state.items.filter((item) => item.id !== deletedId),
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
  },
  effects: (dispatch) => ({
    async load(agencyType) {
      try {
        dispatch.agencys.loadStart();
        const { data, errorMessage } = await listAgencys(agencyType);
        dispatch.agencys.loadSuccess(data);
        if (errorMessage) console.warn(errorMessage);
      } catch (error) {
        console.error(error);
        dispatch.agencys.failure(t("agencys_load_error", { ns: "common" }));
      }
    },
    async create(createProps) {
      try {
        dispatch.agencys.loadStart();
        const { data, errorMessage } = await createAgency(createProps);
        if (errorMessage) console.warn(errorMessage);
        dispatch.agencys.createSuccess(data);
        return data;
      } catch (error) {
        dispatch.agencys.failure(t("agency_create_error", { ns: "common" }));
        throw error;
      }
    },
    async update(updateProps) {
      try {
        dispatch.agencys.loadStart();
        const { data, errorMessage } = await updateAgency(updateProps);
        if (errorMessage) console.warn(errorMessage);
        dispatch.agencys.updateSuccess(data);
        return data;
      } catch (error) {
        dispatch.agencys.failure(t("agency_update_error", { ns: "common" }));
        throw error;
      }
    },
    async delete(id) {
      try {
        dispatch.agencys.loadStart();

        const result = await API.graphql(
          graphqlOperation(mutations.deleteAgency, { input: { id } })
        );
        const deletedId = result.data.deleteAgency.id;
        dispatch.agencys.deleteSuccess(deletedId);
      } catch (error) {
        dispatch.agencys.failure(t("agency_delete_error", { ns: "common" }));
        throw error;
      }
    },
  }),
};

export default agencys;
